<template>
  <div class="form-group row align-items-center">
    <slot name="label">
      <label v-if="label" class="col-3 col-form-label" :class="labelClasses">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>
    <div class="col-3">
      <span class="switch" :class="[{ 'switch-icon': hasIcon == 'true' }]">
        <label>
          <input
            v-bind="$attrs"
            type="checkbox"
            checked="checked"
            v-model="model"
            name="select"
          />
          <span></span>
        </label>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-switch',
  props: {
    label: {
      type: String,
      description: 'switch label',
    },
    name: {
      type: [String, Number],
      description: 'switch label',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    disabled: {
      type: Boolean,
      description: 'Whether switch is disabled',
    },
    required: {
      type: Boolean,
      description: 'Whether switch is required (adds an asterix *)',
    },
    color: {
      type: String,
      description: 'checkbox color',
    },
    value: {
      type: [String, Boolean],
      description: 'switch value',
    },
    inline: {
      type: Boolean,
      description: 'Whether switch is inline',
    },
    items: {
      type: Array,
      description: 'switch button items',
    },
    outline: {
      type: String,
      description: 'switch outline',
    },
    hasIcon: {
      type: String,
      description: 'switch icon',
    },
  },
  data() {
    return {
      cbId: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return '';
    },
  },
  mounted() {},
};
</script>
